import type { Dispatch } from "redux";

import ActivityAction from "../../actions/ActivityAction";
import { ActivityTypes } from "../../constants/action-types";
import type {
  CrmChatRecordContext,
  ManagingPromptAction,
  ManagingPromptActionType,
} from "../types/chat.types";

export { deltaHasInlineCrmActions, parseCrmActionEmbed } from "./crmActionDelta";
export type { CrmActionEmbedData } from "./crmActionDelta";

export function activityTypeForManagingAction(type: ManagingPromptActionType): string {
  switch (type) {
    case "send-email":
      return ActivityTypes.sendEmail;
    case "create-task":
      return ActivityTypes.task;
    case "create-note":
      return ActivityTypes.commented;
    case "schedule-meeting":
      return ActivityTypes.meeting;
    case "schedule-call":
      return ActivityTypes.call;
    default:
      return ActivityTypes.task;
  }
}

export function dueDateFieldsFromPrefill(dueAt?: string): { start?: string; end?: string } {
  if (!dueAt?.trim()) {
    return {};
  }
  const trimmed = dueAt.trim();
  const dateOnly = trimmed.length >= 10 ? trimmed.slice(0, 10) : trimmed;
  return { start: dateOnly, end: dateOnly };
}

export function openManagingPromptAction(
  dispatch: Dispatch,
  record: CrmChatRecordContext,
  action: ManagingPromptAction
): void {
  const activityType = activityTypeForManagingAction(action.type);
  const prefill = action.prefill ?? {};
  const dates = dueDateFieldsFromPrefill(prefill.dueAt);
  dispatch(
    ActivityAction.showActivityDialog(record.recordId, null, {
      item: {
        value: record.recordId,
        label: record.displayName,
        type: record.recordType,
      },
      activityType,
      summary: prefill.summary ?? action.label,
      description: prefill.description ?? "",
      ...(dates.start ? { start: dates.start, end: dates.end ?? dates.start } : {}),
    })
  );
}
